import React, { useEffect, useState } from "react";
import SuccessAnimation from "../../components/common/SuccessAnimation";
import { maskingUtil } from "../../utils/maskingUtil";
import { useLoader } from "../../context/LoaderContext";
import {
  clearCurrentInternalStep,
  clearCurrentStep,
  clearFormData,
  clearQuestionBank,
  clearQuestionSetId,
  getPDFPresent,
  getUser,
  setEditingMode,
} from "../../utils/formStorage";

const SubmissionComplete = () => {
  const { setLoading } = useLoader();
  const pdf = getPDFPresent();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const init = async () => {
      setLoading(false);

      clearCurrentStep();
      clearCurrentInternalStep();
      clearFormData();
      clearQuestionBank();
      setEditingMode(false);
      clearQuestionSetId();
      const currentUser = await getUser();
      setUser(currentUser);
    };

    init();
  }, []);

  return (
    <div
      style={{
        padding: "2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      {/* Success Icon */}
      <SuccessAnimation successMessage="Submitted Successfully !" />

      {/* Subtext */}
      <div
        style={{
          marginTop: "12px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#4B5563",
          textAlign: "center",
          maxWidth: "298px",
          lineHeight: "22px",
        }}
      >
        {pdf ? "A copy of the questionnaire has been sent to your e-mail Id:" : "A copy of the questionnaire will be sent to your e-mail Id:"}
      </div>

      {/* Email */}
      <div
        style={{
          marginTop: "4px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#9CA3AF",
          textAlign: "center",
        }}
      >
        {maskingUtil("email", user?.email || "")}
      </div>

      {/* Yellow Info Box */}
      {pdf ? null : (
        <>
          <div
            style={{
              marginTop: "60px",
              backgroundColor: "#FEF4D7",
              borderRadius: "8px",
              padding: "1.2rem",
              width: "100%",
              maxWidth: "350px",
              display: "flex",
              gap: "0.7rem",
              alignItems: "flex-start",
            }}
          >
            {/* Info Icon */}
            <div>
              <img src="/yellow_info.png" alt="" height={26} />
            </div>

            {/* Text */}
            <div>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#B53F08",
                  marginBottom: "4px",
                }}
              >
                The above copy will be sent only once!
              </div>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "400",
                  color: "#B53F08",
                }}
              >
                Please retain the same for your future reference
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SubmissionComplete;
